import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .top-btn {
    font-size: 1.8rem;
    width: 2.7rem;
    height: 2.7rem;
    color: #fff;
    background-color: #0666a7;
    backdrop-filter: blur(0px);
    box-shadow: ${({ theme }) => theme.colors.shadow};
    border-radius: 25%;
    position: fixed;
    bottom: 3rem;
    right: 3rem;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &--icon {
      animation: gototop 1.2s linear infinite alternate-reverse;
    }

    @keyframes gototop {
      0% {
        transform: translateY(-0.2rem);
      }
      100% {
        transform: translateY(0.5rem);
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .top-btn {
      width: 2.5rem;
      height: 2.5rem;
      bottom: 1.5rem;
      right: 1.5rem;
      border-radius: 50%;
    }
  }
`;
